import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { CancellationService } from '../cancellation/cancellation.service';
import { DefaultResolver } from './default.resolver';

@Injectable()
export class CancellationListResolver extends DefaultResolver implements Resolve<any> {

  constructor(private cancellationService: CancellationService) {
    super();
  }

  resolve(route: ActivatedRouteSnapshot) {
      let criteria = {
          start_date: null,
          end_date: null,
          request: null,
          sample: null,
          du: null,
          page: 1,
          selectedStatus: '',
      };
    let list = this.cancellationService.getCancellationOrders(criteria);
    return list;
  }
}



// WEBPACK FOOTER //
// ./src/app/resolvers/cancellation-list.resolver.ts